<template>
  <v-card class="back" style="height: 800px">
          <scroll-area>
            <template slot="header">
              <v-toolbar dark color="secondary" dense flat>
                <v-toolbar-title>
                  <span v-if="addMode" class="body-2 text-uppercase">{{$t('create new channel')}}</span>
                  <span v-if="!addMode && getData.name" class="body-2 text-uppercase">{{ getData.name }}</span>
                </v-toolbar-title>

                <v-layout  justify-end>
                
                  <v-tooltip v-if="addMode" dark color="secondary" bottom>
                    <v-btn :data-testid="$options.name + 'v-btn' + 'createData'" v-if="addMode" icon flat slot="activator" @click="() => createData()">
                      <svg-icon
                        :color="'white'"
                        :name="'done'"
                        width="20"
                      />
                    </v-btn>
                    <span>{{ $t('create') }}</span>
                  </v-tooltip>

                  <v-tooltip v-if="!addMode && !editMode" dark color="secondary" bottom>
                    <v-btn :data-testid="$options.name + 'v-btn' + 'editMode--editMode'" v-if="!addMode && !editMode" icon flat slot="activator" @click="() => {editMode = !editMode}">
                      <svg-icon
                        :color="'white'"
                        :name="'edit'"
                        width="20"
                      />
                    </v-btn>
                    <span>{{ $t('edit') }}</span>
                  </v-tooltip>

                  <v-tooltip v-if="!addMode && editMode" dark color="secondary" bottom>
                    <v-btn :data-testid="$options.name + 'v-btn' + 'removeItem'" v-if="!addMode && editMode" icon flat slot="activator" @click="() => removeItem()">
                      <svg-icon
                        :color="'white'"
                        :name="'basket'"
                        width="20"
                      />
                    </v-btn>
                    <span>{{ $t('remove') }}</span>
                  </v-tooltip>

                  <v-tooltip v-if="!addMode && editMode" dark color="secondary" bottom>
                    <v-btn :data-testid="$options.name + 'v-btn' + 'saveData'" v-if="!addMode && editMode" icon flat slot="activator" @click="() => saveData()">
                      <svg-icon
                        :color="'white'"
                        :name="'done'"
                        width="20"
                      />
                    </v-btn>
                    <span>{{ $t('save') }}</span>
                  </v-tooltip>

                  <v-tooltip v-if="!addMode && editMode" dark color="secondary" bottom>
                    <v-btn :data-testid="$options.name + 'v-btn' + 'editMode--editMode'" icon v-if="!addMode && editMode" flat slot="activator" @click="() => {editMode = !editMode}">
                      <svg-icon
                        :color="'white'"
                        :name="'close'"
                        width="20"
                      />
                    </v-btn>
                    <span>{{ $t('cancel') }}</span>
                  </v-tooltip>

                  <v-tooltip v-if="!editMode" dark color="secondary" bottom>
                    <v-btn :data-testid="$options.name + 'v-btn' + 'emit-close'" icon v-if="!editMode" flat slot="activator" @click="()=>{$emit('close')}">
                      <svg-icon
                        :color="'white'"
                        :name="'close'"
                        width="20"
                      />
                    </v-btn>
                    <span>{{ $t('close') }}</span>
                  </v-tooltip>
                  
                </v-layout>

              </v-toolbar>             
            </template>

            <template slot="body">
              <v-container fill-height pa-0>
              <v-layout column fill-height justify-start class="pa-2">
                <v-form ref="CHANNEL_card_form">

                  <v-layout  justify-start class="pb-2">

                    <v-flex xs6 shrink pa-0 >
                      <v-layout shrink v-for="(field, index) in getFields" :key="index" v-if="field.show == 'true' && field.type != 'timestamp'" >
                        <v-flex xs4 shrink v-if="field.type != 'boolean' && field.type != 'select' && field.type != 'select_enum'" pa-0 >
                          <v-text-field
                            :value="$t(field.name)"
                            light
                            auto-grow
                            single-line
                            flat
                            readonly
                            disabled
                            class="white"
                            persistent-hint
                            hide-details
                            
                            :rows="1"
                            color="grey"
                          >
                          </v-text-field>
                        </v-flex>
                        
                        <v-flex xs8 shrink field.type != 'boolean' pa-0>

                          <v-tooltip v-if="getDescriptions[field]" dark color="secondary" bottom>

                            <v-text-field
                              v-if="field.type == 'integer'"
                              slot="activator"
                              v-model.number="model.obj[field.name]"
                              :data-testid="$options.name + '_v-text-field_integer_' + field.name"
                              :type="'number'"
                              :readonly="!addMode && !editMode"
                              :disabled="!addMode && !editMode"
                              light
                              auto-grow
                              single-line
                              flat
                              class="white"
                              persistent-hint
                              hide-details                     
                              :rows="1"
                              color="accent"
                            >
                            </v-text-field>

                            <v-text-field
                              v-else
                              slot="activator"
                              v-model="model.obj[field.name]"
                              :data-testid="$options.name + '_v-text-field_' + field.name"
                              light
                              :readonly="!addMode && !editMode"
                              :disabled="!addMode && !editMode"
                              auto-grow
                              single-line
                              flat
                              class="white"
                              persistent-hint
                              hide-details                     
                              :rows="1"
                              color="accent"
                            >
                            </v-text-field>
                            <span >{{ $t(getDescriptions[field.name]) }}</span>
                          </v-tooltip>

                          <v-text-field
                            v-if="!getDescriptions[field.name] && field.type == 'integer'"
                            v-model.number="model.obj[field.name]"
                            :data-testid="$options.name + '_v-text-field_' + field.name"
                            :rules="model.fields[field.name] && model.fields[field.name].required ? [value => !!value || $t('required')] : []"
                            :required="model.fields[field.name].required"
                            :type="'number'"
                            :readonly="!addMode && !editMode"
                            :disabled="!addMode && !editMode"
                            light
                            auto-grow
                            single-line
                            flat
                            class="white"
                            persistent-hint
                            hide-details                     
                            :rows="1"
                            color="accent"
                          >
                          </v-text-field>
                          
                          <v-text-field
                            v-if="!getDescriptions[field.name] && field.type == 'text'"
                            v-model="model.obj[field.name]"
                            :data-testid="$options.name + '_v-text-field_' + field.name"
                            :rules="model.fields[field.name] && model.fields[field.name].required ? [value => !!value || $t('required')] : []"
                            :required="model.fields[field.name].required"
                            light
                            :readonly="!addMode && !editMode"
                            :disabled="!addMode && !editMode"
                            auto-grow
                            single-line
                            flat
                            class="white"
                            persistent-hint
                            hide-details                     
                            :rows="1"
                            color="accent"
                          >
                          </v-text-field>

                        </v-flex>

                      </v-layout>
                    </v-flex>

                    <v-flex xs6 shrink pl-2 >
                      <v-layout shrink v-for="(field, index) in getFields" :key="index" v-if="field.show == 'true' && field.type != 'timestamp'" >
                        <v-flex xs4 shrink v-if="field.type != 'boolean' && (field.type == 'select' || field.type == 'select_enum')" pa-0 >
                          <v-text-field
                            :value="$t(field.name)"
                            :data-testid="$options.name + '_v-text-field_' + field.name"
                            light
                            auto-grow
                            single-line
                            flat
                            readonly
                            disabled
                            class="white"
                            persistent-hint
                            hide-details
                            :rows="1"
                            color="grey"
                          >
                          </v-text-field>
                        </v-flex>
                        
                        <v-flex xs8 shrink field.type != 'boolean' pa-0>

                          <v-select
                            v-if="(field.type == 'select' || field.type == 'select_enum') && field.name != 'template'"
                            v-model="model.obj[field.name]"
                            :data-testid="$options.name + '_v-select_' + field.name"
                            light
                            :readonly="!addMode && !editMode"
                            :disabled="!addMode && !editMode"
                            :rules="model.fields[field.name] && model.fields[field.name].required ? [value => !!value || $t('required')] : []"
                            required
                            :items="getItems[field.cls]"
                            :item-text="field.type == 'select' ? 'name' : 'value'"
                            :item-value="field.type == 'select' ? '$id' : 'id'"
                            single-line
                            hide-details
                            flat
                            class="white"
                            background-color="white"
                            
                          >
                            <template v-slot:item="{ item, index }">
                                <span>{{ $t(field.type == 'select' ? item.name : item.value) }}</span>
                            </template>
                            <template v-slot:selection="{ item, index }">
                                <span>{{ $t(field.type == 'select' ? item.name : item.value) }}</span>
                            </template>
                          </v-select>

                          <v-select
                            v-if="(field.type == 'select' || field.type == 'select_enum') && field.name == 'template'"
                            v-model="model.obj[field.name]"
                            :data-testid="$options.name + '_v-select_' + field.name"
                            light
                            :readonly="!addMode && !editMode"
                            :disabled="!addMode && !editMode"
                            :rules="model.fields[field.name] && model.fields[field.name].required ? [value => !!value || $t('required')] : []"
                            required
                            :items="getItems[field.cls]"
                            item-text="id"
                            item-value="id"
                            single-line
                            hide-details
                            flat
                            class="white"
                            background-color="white"
                            
                          >
                            <template v-slot:item="{ item, index }">
                                <span>{{ $t(item.id) }}</span>
                            </template>
                            <template v-slot:selection="{ item, index }">
                                <span>{{ $t(item.id) }}</span>
                            </template>
                          </v-select>

                        </v-flex>

                      </v-layout>
                    </v-flex>

                  </v-layout>

                  <v-layout row v-if="getFields" justify-end align-center class="white" >
                    <v-flex xs6 v-for="(field, index) in getFields" :key="index" v-if="field.show == 'true' && field.type == 'timestamp'">
                      <date-picker
                        :value="model.obj[field.name]"
                        :label="field.name"
                        :readonly="!addMode && !editMode"
                        :disabled="!addMode && !editMode"
                        @dateChange="(payload) => {onDateChange(payload, field.name)}"
                      />

                    </v-flex>
                  </v-layout>

                  <v-layout row v-if="getFields" justify-space-between align-center class="white" >
                    <v-flex xs12 v-for="(field, index) in getFields" :key="index" v-if="field.show == 'true' && field.type == 'boolean'">
                      <v-checkbox
                        small
                        light
                        color="secondary"
                        v-if="field.type == 'boolean'"
                        v-model="model.obj[field.name]"
                        :data-testid="$options.name + '_v-checkbox_' + field.name"
                        :readonly="!addMode && !editMode"
                        :disabled="!addMode && !editMode"
                      >
                        <template v-slot:label>
                          <span class="black--text" v-if="model.fields[field.name] && model.fields[field.name].required">{{$t(field.name) + ' *'}}</span>
                          <span class="black--text" v-else>{{$t(field.name)}}</span>
                        </template>
                      </v-checkbox>
                    </v-flex>
                  </v-layout>

                  
                  <v-layout  fill-height column justify-start align-center class="white" style="height: 34vh" >
                    <v-toolbar v-if="getTable.rows?.length" dark color="secondary" dense flat>
                      <v-toolbar-title>
                        <span class="body-2 text-uppercase">{{$t('connections')}}</span>
                      </v-toolbar-title>
                    </v-toolbar>
                    <scroll-table
                      :data="getTable"
                      :options="getOptions"
                      :subscribed="true"
                      :headUppercase="false"
                      :hover="false"
                      
                      :translate="true"
                      @select="(payload) => onConnectionSelect(payload)"
                      @value=""
                      @remove=""
                    />
                  </v-layout>

                </v-form>
              </v-layout>
              </v-container>
            </template>
          </scroll-area>

  </v-card>
</template>

<script lang="ts">
import Vue from 'vue'
import loadingCircle from '@/nms/components/partials/loader.vue'
import scrollTable from '@/nms/components/partials/scrolltable.vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import crumbs from '@/nms/components/partials/bread-crumbs.vue'
import svgIcon from '@/nms/components/media/svg/static/svg-icon.vue'
import datePicker from '@/nms/components/controls/input-menu-datepicker.vue'
import LogicalTree from '@/nms/pages/services/logical-tree.vue'
import Connections from '@/nms/pages/services/connections.vue'

// Типы
interface EndpointRef {
  $ref_id?: string
  ref: string
  type: string
  $id?: string
  namePath?: string[]
  [key: string]: any
}

interface ConnectionRef {
  ref: string
  type: string
  $id?: string
  [key: string]: any
}

interface ConnectionItem {
  $id?: string
  id?: string
  name?: string
  cls?: string
  template?: string
  port_type?: string
  selected?: boolean
  refs?: EndpointRef[]
  brefs?: any[]
  points?: EndpointRef[]
  point_a?: Array<{ path: string; obj: EndpointRef }>
  point_b?: Array<{ path: string; obj: EndpointRef }>
  services?: string[]
  [key: string]: any
}

interface ModelData {
  fields: Record<string, any>
  obj: Record<string, any>
  items: Record<string, any>
  refs: {
    connection?: ConnectionItem[]
    endpoint?: EndpointRef[]
    [key: string]: any
  }
}

interface MetaData {
  [key: string]: any
}

interface ChannelData {
  $id?: string
  id?: string
  name?: string
  cls?: string
  meta?: () => Promise<MetaData>
  [key: string]: any
}

interface ParentData {
  [key: string]: any
}

interface DescriptorData {
  [key: string]: any
}

interface DescriptionsData {
  [key: string]: any
}

interface TableColumn {
  title: string
  value: string
  type: string
  width: string
  disabled?: boolean
}

interface TableData {
  columns: TableColumn[]
  rows: ConnectionItem[]
}

interface OptionsColumns {
  [key: string]: { width: string }
}

interface OptionsData {
  columns: OptionsColumns
}

interface BridgeObject {
  $id?: string
  $ref_id?: string
  _cmdb_?: boolean
  cls?: string
  name?: string
  s$children?: string[]
  getParents?: (options?: any) => Promise<any[]>
  getMeta?: () => Promise<MetaData>
  [key: string]: any
}

export default Vue.extend({
  name: 'CHANNEL_CARD',

  components: {
    loadingCircle,
    scrollTable,
    scrollArea,
    crumbs,
    svgIcon,
    datePicker,
    LogicalTree,
    Connections
  },

  props: {
    data: {
      type: Object as () => ChannelData,
      default: () => ({})
    },
    parentData: {
      type: Object as () => ParentData,
      default: () => ({})
    },
    descriptor: {
      type: Object as () => DescriptorData,
      default: () => ({})
    },
    addMode: {
      type: Boolean,
      default: () => false
    },
    descriptions: {
      type: Object as () => DescriptionsData,
      default: () => ({})
    },
    localConnections: {
      type: Array as () => ConnectionItem[],
      default: () => []
    },
  },

  data(): {
    editMode: boolean
    meta: MetaData | null
    connections: ConnectionItem[]
    model: ModelData
    dataObj: any | null
    showTree: boolean
    options: OptionsData
    search: string
    table: TableData
    getEdited?: ChannelData
  } {
    return {
      editMode: false,
      meta: null,
      connections: [],
      model: {
        fields: {},
        obj: {},
        items: {},
        refs: {},
      },
      dataObj: null,
      showTree: false,
      options: {
        columns: {
          text: { width: '40%' },
          timestamp: { width: '40%' },
          actions: { width: '40%' },
          check: { width: '20%' },
          check_dependence: { width: '5%' },
        },
      },
      search: '',
      table: {
        columns: [],
        rows: []
      },
    }
  },

  watch: {
    'model.obj.template': {
      handler(newVal: string, oldVal: string): void {
        console.log('WATCH', 'CHANNEL_CARD', 'TEMPLATE oldVal', oldVal)
        console.log('WATCH', 'CHANNEL_CARD', 'TEMPLATE newVal', newVal)
        if (newVal === oldVal) return
        this.$set(this.model.refs, 'connection', [])
        this.prepareColumns()
      },
      deep: true
    },
  },

  computed: {
    getData(): ChannelData {
      return this.data
    },
    getDataObj(): any | null {
      return this.dataObj
    },
    getFields(): Record<string, any> {
      return this.model.fields
    },
    getItems(): Record<string, any> {
      return this.model.items
    },
    getDescriptions(): DescriptionsData {
      return this.descriptions
    },
    getConnections(): ConnectionItem[] {
      return this.connections.map(connection => connection)
    },
    getlocalConnections(): ConnectionItem[] {
      return this.localConnections.map(connection => connection)
    },
    getTable(): TableData {
      const t = this.$merge({}, this.table) as TableData
      if (this.search.length) {
        const searchLower = this.search.toLowerCase()
        t.rows = t.rows.filter(row => {
          return row.name?.toLowerCase().indexOf(searchLower) > -1
        })
        return t
      }
      return this.table
    },
    getOptions(): OptionsData {
      return this.options
    },
  },

  created(): void {
    this.setup()
  },

  methods: {
    async setup(): Promise<void> {
      this.$set(this.model, 'fields', {})
      this.$set(this.model, 'items', {})
      this.$set(this.model, 'obj', {})
      this.$set(this.model, 'refs', {})

      await this.loadMeta()
      await this.loadConnections()
      this.prepareColumns()
      this.showTree = true
      console.log('CHANNEL_CARD', 'setup', 'this.getlocalConnections', this.getlocalConnections)
    },

    async loadConnections(): Promise<void> {
      console.log('CHANNEL_CARD', 'loadConnections', 'START')

      try {
        const query = {
          id: ['/logical/connection'],
          notNull: true,
          namePath: true,
          data: {
            children: {
              data: {
                children: true,
                namePath: true,
                refs: {
                  data: {
                    namePath: true,
                    path: true,
                    refs: {
                      data: {
                        namePath: true,
                        path: true,
                      }
                    },
                  }
                },
                brefs: {
                  data: {
                    namePath: true,
                    path: true,
                  }
                },
              },
              refs: true
            },
          }
        }
        const connections = await this.$bridge.cmdbQuery(query)
        if (connections?.[0]?.children?.length) {
          console.log('CHANNEL_CARD', 'loadConnections', 'connections', connections[0].children)
          this.connections = connections[0].children.map((connection: ConnectionItem) => {
            connection.selected = false
            return connection
          })
        }
      } catch (error) {
        console.error('CONNECTIONS', 'loadConnections smth wrong', error)
      }
    },

    async loadMeta(caller?: string): Promise<void> {
      try {
        this.setLoader('loadMeta', true)
        this.dataObj = this.getData || await this.$bridge.getByPath('/logical/channel')
        this.meta = this.getData?.$id 
          ? await this.getData.meta?.() 
          : await this.$bridge.getMeta(this.dataObj.s$children[0])
        
        if (this.meta) {
          this.model = await this.$prepareMeta(this.meta, this.$options.name)
          const $_templates = this.getData?.$id 
            ? await this.$bridge.getTemplates(this.dataObj.cls)
            : await this.$bridge.getTemplates(this.dataObj.s$children[0])
          this.$set(this.model.items, 'template', $_templates)
          if (!this.addMode) {
            this.prepareData()
          }
        }
        this.setLoader('loadMeta', false)
      } catch (error) {
        this.setLoader('loadMeta', false)
        console.error('loadMeta error', error)
      }
    },

    async prepareData(): Promise<void> {
      try {
        const model = await this.$prepareData(this.model, this.getData, this.meta, this.$options.name)
        console.log(this.$options.name, 'prepareData', 'model', model)
        this.model = model
      } catch (error) {
        this.setLoader('loadMeta', false)
        console.error('prepareData error', error)
      }
    },

    prepareColumns(): void {
      this.table = {
        columns: [
          {
            title: 'name',
            value: 'name',
            type: 'text',
            width: '20%'
          },
          {
            title: 'type',
            value: 'template',
            type: 'text',
            width: '10%'
          },
          {
            title: 'point_a',
            value: 'point_a',
            type: 'endpoint_subscrybed',
            width: '20%'
          },
          {
            title: 'point_b',
            value: 'point_b',
            type: 'endpoint_subscrybed',
            width: '20%'
          },
        ],
        rows: []
      }

      if (this.addMode) {
        this.table.columns.push({
          title: 'select',
          value: 'selected',
          type: 'check_box',
          disabled: true,
          width: '10%'
        })
      }
      this.prepareRows()
    },

    async prepareRows(): Promise<void> {
      let connections$: ConnectionItem[] = []

      if (this.getDataObj?.refs?.length) {
        connections$ = this.getDataObj.refs.filter((connection: ConnectionItem) => {
          return connection.cls === 'connection'
        })
      } else if (this.getConnections.length) {
        connections$ = this.connections
      } else {
        return
      }

      if (this.model.obj.template) {
        connections$ = connections$.filter(conn => {
          return conn.port_type?.includes(this.model.obj.template)
        })
      }

      console.log('CONNECTIONS', 'connections$.map', 'connections$', connections$)
      this.table.rows = connections$.map(connection => {
        if (connection.refs?.length) {
          connection.points = []
          connection.refs.forEach(ref => {
            if (ref.ref === 'endpoint') {
              connection.points?.push(ref)
            }
          })
          
          if (connection.points?.length) {
            const point = connection.points[0].namePath
            connection.point_a = [{
              path: point?.slice(10) || '',
              obj: connection.points[0]
            }]
            
            if (connection.points[1]) {
              const point = connection.points[1].namePath
              connection.point_b = [{
                path: point?.slice(10) || '',
                obj: connection.points[1]
              }]
            }
          }
        }

        if (connection.brefs?.length) {
          connection.services = []
          connection.brefs.forEach(bref => {
            if (bref.ref === 'connection') {
              connection.services?.push(`${bref.name} (${bref.port_type})`)
            }
          })
        }
        
        return connection
      })
      console.log('CHANNEL_CARD', 'prepareRows', 'table', this.table)
      console.log('CHANNEL_CARD', 'prepareRows', 'this.connections', this.connections)
    },

    async onConnectionSelect(payload: ConnectionItem): Promise<void> {
      console.log('CHANNEL_CARD', 'onConnectionSelect', 'val', payload)
      if (!payload?.$id) return
      
      try {
        if (!this.model.refs.connection) {
          this.$set(this.model.refs, 'connection', [])
        }
        
        if (this.model.refs.connection.length) {
          const duplicateIndex = this.model.refs.connection.findIndex(connection$ => connection$.$id === payload.$id)
          console.log('CHANNEL_CARD', 'CONNECTIONS', 'duplicateIndex', duplicateIndex, 'payload', payload)
          
          if (duplicateIndex < 0) {
            this.$set(this.model.refs.connection, this.model.refs.connection.length, payload)
          } else {
            const arr = this.model.refs.connection.filter(c => c.$id !== payload.$id)
            this.$set(this.model.refs, 'connection', arr)
          }
        } else {
          this.$set(this.model.refs.connection, this.model.refs.connection.length, payload)
        }

        this.connections.forEach(connection => {
          if (connection.$id === payload.$id) {
            this.$set(connection, 'selected', !connection.selected)
          }
        })

        console.log('CHANNEL_CARD', 'onConnectionSelect', 'this.model.refs.connection', this.model.refs.connection)
      } catch (error) {
        console.error('CHANNEL_CARD', 'onConnectionSelect', 'error', error)
      }
    },

    async onEndpointSelect(val: BridgeObject, point: string): Promise<void> {
      console.log('CHANNEL_CARD', 'ENDPOINTS', 'val', val, 'point', point)
      
      const payload = val._cmdb_ ? val : await this.$bridge.getObjectById(val.$id)
      const index = point === 'start' ? 0 : 1

      try {
        if (!this.model.refs.endpoint) {
          this.$set(this.model.refs, 'endpoint', [])
        }
        
        if (this.model.refs.endpoint.length) {
          const duplicate = this.model.refs.endpoint.some(endpoint$ => endpoint$.$id === payload.$id)
          console.log('CHANNEL_CARD', 'ENDPOINTS', 'duplicate', duplicate, 'payload', payload)
          
          if (duplicate) {
            this.$dialog.notify.error(this.$getTranslate('port is already selected'), {
              timeout: 2000
            })
            return
          }
        }

        if (point && payload.getParents) {
          const parents = await payload.getParents()
          if (parents?.length) {
            const p$ = parents.filter(parent => {
              return parent.cls === 'device' || parent.cls === 'slot' || 
                     parent.cls === 'module' || parent.cls === 'submodule' || parent.cls === 'port'
            })
            payload.parent = p$
            
            const l$ = parents.filter(parent => {
              return parent.cls === 'location' || parent.cls === 'cabinet'
            })
            payload.location = l$
            
            this.$set(this.model.refs.endpoint, index, { ...this.model.refs.endpoint[index], ...payload })
          }
        }
      } catch (error) {
        console.error('CHANNEL_CARD', 'onEndpointSelect', 'error', error)
      }
    },

    onDateChange(payload: any, fieldName: string): void {
      this.$set(this.model.obj, fieldName, payload)
    },

    removeItem(): void {
      this.$dialog.confirm({
        text: `Удалить ${this.getData.name}?`,
        title: 'Удаление',
        actions: {
          false: 'Отмена',
          true: {
            color: 'red',
            text: 'Удалить',
            handle: () => {
              this.$emit('remove', this.getData)
            }
          }
        }
      })
    },

    async saveData(): Promise<void> {
      console.log('this.model.obj', this.model.obj)
      try {
        this.$dialog.confirm({
          text: 'Сохранить изменения?',
          title: 'Сохранение',
          actions: {
            false: 'Отмена',
            true: {
              color: 'green',
              text: 'Сохранить',
              handle: () => {
                this.$emit('update', this.model.obj)
                this.$emit('close')
              }
            }
          }
        })
      } catch (err) {
        this.$errorHandler(err)
      }
    },

    async createData(): Promise<void> {
      const formRef = this.$refs['CHANNEL_card_form'] as any
      const v = formRef?.validate() ?? false
      
      if (!v) return

      const data$: Record<string, any> = {}
      const fields = Object.keys(this.model.obj)
      fields.forEach(field => {
        data$[field] = this.model.obj[field]
      })

      const refs$: ConnectionRef[] = []
      console.log('CHANNEL_CARD', 'createData', 'model', this.model)
      
      if (this.model.refs.connection?.length) {
        this.model.refs.connection.forEach(connection => {
          const ref$: ConnectionRef = {
            ref: 'connection',
            type: 'stateRef',
            $id: connection.$id
          }
          refs$.push(ref$)
        })
      }
      data$.refs = refs$

      try {
        const edited = (this as any).getEdited as ChannelData | undefined
        
        if (edited?.$id) {
          const $obj = await this.$bridge.getObjectById(edited.$id)
          const c = await $obj.update(data$)
          if (c) {
            this.$dialog.notify.success('Изменения успешно внесены!', { timeout: 5000 })
            await this.$store.dispatch('updateObject', { $id: c.$id })
            this.$bridge.litePolling(c.$id)
            this.$emit('update')
            this.$emit('close')
          } else {
            this.$dialog.notify.error(this.$getTranslate('something wrong with channel'), { timeout: 5000 })
          }
        } else {
          const $obj = await this.$bridge.getObjectById(this.dataObj.$id)
          console.log('CHANNEL_CARD', 'createData', '$obj', $obj)
          console.log('CHANNEL_CARD', 'createData', 'data$', data$)
          const c = await $obj.createChild($obj.s$children[0], data$)
          if (c) {
            this.$dialog.notify.success('Канал успешно создан!', { timeout: 5000 })
            await this.$store.dispatch('updateObject', { $id: c.$id })
            this.$bridge.litePolling(c.$id)
            this.$emit('update')
            this.$emit('close')
          } else {
            this.$dialog.notify.error(this.$getTranslate('something wrong with channel'), { timeout: 5000 })
          }
        }
      } catch (err) {
        this.$errorHandler(err)
      }
    },

    setLoader(name: string, status: boolean): void {
      this.$store.dispatch('setLoader', {
        key: name,
        value: status
      })
    },
  },
})
</script>

<style lang="stylus" scoped>
.rule
  border 1px solid #c1c163
  margin-bottom: 5px;
  padding: 5px;
.rule-item
  //border 1px solid red
  display flex
  justify-content stretch
  align-items baseline
  .field
    margin 0 3px
    outline: darkgray solid 1px;
    height: 30px;
    padding-left: 5px;
    line-height: 30px;
    background-color: white;
.v-btn.supersmall
  padding-top: 4px
  height: 24px
  width: 24px
  right: 5px
</style>
